import React, { createContext, useState, useEffect } from 'react';
import firebase from 'firebase';
import { v4 as uuid } from 'uuid';

const PedalsCtx = createContext('pedalsCtx');

export const PedalsProvider = ({ children }) => {
  const [pedals, setPedals] = useState();
  const [pedalsLoading, setPedalsLoading] = useState(false);
  const [pedalsList, setPedalsList] = useState([]);

  const addToPedalsList = (pedal) => {
    setPedalsList([
      ...pedalsList,
      {
        key: uuid(),
        ...pedal
      }
    ]);
  }

  useEffect(() => {
    const exec = async () => {
      setPedalsLoading(true);
      try {
        const data = await firebase.firestore().collection('pedals').get();
        setPedals(data.docs.map(item => ({ ...item.data(), id: item.id })));
      } catch(e) {
        console.log(e);
      }
      setPedalsLoading(false);
    }
    exec();
  }, []);

  return (
    <PedalsCtx.Provider
      value={{
        state: {
          pedals,
          pedalsLoading,
          pedalsList,
          setPedalsList,
          addToPedalsList
        },
      }}
    >
      {children}
    </PedalsCtx.Provider>
  );
};

export const withPedalsProvider = (Component) => (props) => (
  <PedalsProvider>
    <Component {...props} />
  </PedalsProvider>
)

export const withPedalsCtx = (Component) => (props) => (
  <PedalsCtx.Consumer>
    {state => <Component {...props} pedalsCtx={state} />}
  </PedalsCtx.Consumer>
);